import { apiClient } from './client';
import type { LoginCredentials, LoginResponse, ValidateResponse } from '@/types';

export const authAPI = {
  login: (credentials: LoginCredentials) => 
    apiClient.post<LoginResponse>('/auth/login', credentials),

  logout: () => 
    apiClient.post('/auth/logout'),

  validate: () => 
    apiClient.get<ValidateResponse>('/auth/validate'),

  refresh: () => 
    apiClient.post('/auth/refresh'),
};